import { FormikErrors } from 'formik'
import { useTranslation } from 'react-i18next'
import { EscritosFormValues } from 'src/components/views/EscritosLexnet/components/shared/types/escritosFormTypes'
import { FormField } from 'src/enums/Form'
// import { DocumentoPrincipalType } from 'src/interfaces/EscritosLegales'

type Props = {
  errors: FormikErrors<EscritosFormValues>
  // documentoPrincipal: DocumentoPrincipalType
}

export default function ShowErrorsDialog({ errors }: Props): JSX.Element {
  const formErrors = Object.keys(errors)
  let showResolucionError = true
  let showDatosError = true
  let showOrganismoOrigenError = true
  const { t } = useTranslation()

  function renderDocumentoPrincipalErrorType(): JSX.Element {
    // return documentoPrincipal.archivo ? (
    //   <span>
    //     Indicar tipo de <strong>{t('form.field.catalogacion')}</strong> en
    //     <strong> {t('form.legend.documento_principal')}</strong>.
    //   </span>
    // ) : (
    //   <span>
    //     Adjuntar <strong>{t('form.legend.documento_principal')}</strong>.
    //   </span>
    // )
    return <strong>{t('form.legend.documento_principal')}</strong>
  }

  function renderDocumentoAnexosErrorType(): JSX.Element {
    const anexosError = errors[FormField.DOCUMENTOS_ANEXOS]
    if (typeof anexosError === 'string') {
      return <strong>{anexosError}</strong>
    }
    return <strong>{t('form.legend.documentos_anexos')}</strong>
  }


  function renderResolucionError() {
    // return showResolucionError ? (
    //   <Trans i18nKey="form.errors.show_errors_dialog_general">
    //     {{ fieldset: t('form.legend.resolucion') }}
    //   </Trans>
    // ) : null
    return showResolucionError ? <strong>{t('form.legend.resolucion')}</strong> : null
  }

  function renderDatosError() {
    // return showDatosError ? (
    //   <Trans i18nKey="form.errors.show_errors_dialog_general">
    //     {{ fieldset: t('form.legend.datos') }}
    //   </Trans>
    // ) : null
    return showDatosError ? <strong>{t('form.legend.datos')}</strong> : null
  }

  function renderOrganismoOrigenError() {
    // return showOrganismoOrigenError ? (
    //   <Trans i18nKey="form.errors.show_errors_dialog_general">
    //     {{ fieldset: t('form.field.datos_organismo_origen') }}
    //   </Trans>
    // ) : null
    return showOrganismoOrigenError ? (
      <strong>{t('form.field.datos_organismo_origen')}</strong>
    ) : null
  }

  const textErrors = formErrors
    .map(error => {
      let text: any = ''
      switch (error) {
        case FormField.REMITENTE_TITULAR:
          text = <strong>{t('form.field.titular')}</strong>
          break
        case FormField.ORGANO_DESTINO_DESCRIPCION:
          text = <strong>{t('form.legend.destino')}</strong>
          break
        case FormField.PROCEDIMIENTO_DESCRIPCION:
          text = <strong>{t('form.field.procedimiento')}</strong>
          break
        case FormField.ORGANO_ORIGEN_ORGANISMO_ORIGEN:
        case FormField.ORGANO_ORIGEN_NUMERO_EXPEDIENTE:
        case FormField.ORGANO_ORIGEN_YEAR_EXPEDIENTE:
          text = renderOrganismoOrigenError()
          showOrganismoOrigenError = false
          break
        case FormField.NIG_FULL_NUMBER:
          text = <strong>{t('form.legend.NIG')}</strong>
          break
        case FormField.DATOS_TIPO_CUANTIA:
        case FormField.DATOS_CUANTIA_RECONVENCION:
        case FormField.DATOS_MATERIA:
        case FormField.DATOS_CUANTIA_PRINCIPAL:
        case FormField.DATOS_CUANTIA_INTERESES_REMUNERATORIOS:
        case FormField.DATOS_CUANTIA_INTERESES_DEMORA:
        case FormField.DATOS_CUANTIA_COMISION_IMPAGO_RECIBOS:
        case FormField.DATOS_CUANTIA_PENALIZACION_RETRASO_PAGO:
        case FormField.DATOS_DELITO:
        case FormField.DATOS_FECHA_ACUERDO:
        case FormField.DATOS_FECHA:
        case FormField.DATOS_YEAR_EXPEDIENTE_ORIGEN:
        case FormField.DATOS_ORGANISMO_ORIGEN:
        case FormField.DATOS_ORGANISMO:
        case FormField.DATOS_HORA:
          text = renderDatosError()
          showDatosError = false
          break
        case FormField.DOCUMENTO_PRINCIPAL:
          text = renderDocumentoPrincipalErrorType()
          break

        case FormField.DOCUMENTOS_ANEXOS:
          text = renderDocumentoAnexosErrorType()
          break
          // text = <strong>{t('form.legend.documentos_anexos')}</strong>
          // break

        case FormField.INTERVINIENTES_FROM_LEXON_VALIDATED:
        case FormField.INTERVINIENTES:
          text = <strong>{t('form.legend.intervinientes')}</strong>
          break
        case FormField.ORGANO_ORIGEN_DESCRIPCION:
          text = <strong>{t('form.legend.organo_origen')}</strong>
          break
        case FormField.TIPO_RESOLUCION:
        case FormField.FECHA_RESOLUCION:
        case FormField.NUMERO_RESOLUCION:
        case FormField.YEAR_RESOLUCION:
          text = renderResolucionError()
          showResolucionError = false
          break
        default:
          return null
      }

      return text
    })
    .filter(e => e !== null)

  return (
    <div>
      {t('dialog.message.uncompleted_form_message')}
      {textErrors.map((e, index) => {
        let separator = ', '

        if (textErrors.length - 1 === index) {
          separator = '.'
        } else if (textErrors.length >= 2 && textErrors.length - 2 === index) {
          separator = ' y '
        }

        return (
          <span key={`error_${index}`}>
            {e}
            {separator}
          </span>
        )
      })}
    </div>
  )
}
